import React, { useContext, useEffect, useRef, useState } from "react";
import { FaArrowLeft, FaCheckCircle, FaSearch, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import buildLink from "../../../urls";
import axios from "axios";
import Cookies from "js-cookie";
import { format } from "date-fns";
import { CompanyContext } from "../../../contexts/companyCotext";
import Loader from "../../../components/loader";
import MessageAlert from "../../../components/messageAlert";
import hocStarredPage from "../../../components/hocStarredPage";
import { PlaySounds } from "../../../functions/playSounds";
import Header from "../../../components/Header";
import { LogisticContext } from "../../../contexts/logisticContext";
import { getDetectedOrderType } from "../../../functions/getDetectedOrderType";
import { axiosServer } from "../../../axiosServer";

const HoldStatuses = ({ origin_type }) => {
  const orderId = useRef(null);
  const neworderId = useRef(null);
  const [numberofpackages, setNumberofpackages] = useState(null);
  const [message, setMessage] = useState("");
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [show, setShow] = useState(true);
  const [splitScanProgress, setSplitScanProgress] = useState(null);
  const options = [
    { value: "normal", label: "Normal" },
    { value: "return", label: "Return" },
  ];
  const [selectedOption, setSelectedOption] = useState(options[0]);

  const [orderType, setOrderType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [logisticSelect, setLogisticSelect] = useState(null);
  const [stateCom, dispatchCom] = useContext(CompanyContext);
  const [stateLogistic] = useContext(LogisticContext);
  const constNumPack = useRef(0);
  const [orderList, setOrdersList] = useState([]);
  const [orderStatus, setorderStatus] = useState("normal");
  const [OldOrderId, setOldOrderId] = useState(null);
  const [selectedLogistics, setSelectedLogistics] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const driverRequestId = useRef(0);
  var host = window.location.host;

  let orderListCookies =
    Cookies.get("ordersHistory") === undefined
      ? []
      : JSON.parse(Cookies.get("ordersHistory"));
  var orderListVar = orderListCookies;

  const getUserIdFromLocalStorage = () => {
    return localStorage.getItem("userID");
  };

  const syncPackageFlowVisibility = (value = "") => {
    const shouldShowPackageFlow = !value.trim().includes("-");
    setShow(shouldShowPackageFlow);

    if (shouldShowPackageFlow && value.trim()) {
      setSplitScanProgress(null);
    }

    if (!shouldShowPackageFlow) {
      setNumberofpackages(null);
      constNumPack.current = 0;
      if (orderId.current) {
        orderId.current.value = "";
      }
    }
  };

  const resetPackageFlow = () => {
    setShow(true);
    setNumberofpackages(null);
    setSplitScanProgress(null);
    constNumPack.current = 0;
    if (orderId.current) {
      orderId.current.value = "";
    }
  };

  const updateSplitScanProgress = (data = {}) => {
    const totalPackages = Number(data?.total_packages ?? 0);
    const checkedPackages = Number(data?.checked_packages ?? 0);
    const remainingPackages = Number(
      data?.remaining_packages ?? Math.max(totalPackages - checkedPackages, 0),
    );

    if (
      totalPackages === 0 &&
      checkedPackages === 0 &&
      remainingPackages === 0
    ) {
      return;
    }

    setSplitScanProgress({
      totalPackages,
      checkedPackages,
      remainingPackages,
    });
  };

  const fetchDrivers = async (logisticId, orderType = "normal") => {
    const requestId = ++driverRequestId.current;

    try {
      if (!logisticId) {
        setDrivers([]);
        setSelectedDriver(null);
        return;
      }

      const url =
        buildLink("getDrivers") +
        `&logistic_id=${logisticId}&order_type=${orderType}`;
      const response = await axiosServer.get(url);

      if (requestId === driverRequestId.current && response.data.success) {
        const driverOptions = (response.data.data || []).map((driver) => ({
          value: driver.driver_id,
          label: driver.name,
          normal_logistic_id: driver.normal_logistic_id,
          return_logistic_id: driver.return_logistic_id,
        }));

        if (driverOptions.length > 0) {
          setDrivers(driverOptions);
        }
      }
    } catch (error) {
      console.error("Error fetching drivers:", error);
    }
  };

  useEffect(() => {
    if (selectedLogistics && selectedLogistics.length === 1) {
      const logistic = selectedLogistics[0];

      if (logistic.enable_driver === "1" || logistic.enable_driver === 1) {
        const logisticId = logistic.value;
        fetchDrivers(logisticId, orderStatus);
      } else {
        driverRequestId.current += 1;
        setDrivers([]);
        setSelectedDriver(null);
      }
    } else if (selectedLogistics && selectedLogistics.length > 1) {
      driverRequestId.current += 1;
      setDrivers([]);
      setSelectedDriver(null);
    } else {
      driverRequestId.current += 1;
      setDrivers([]);
      setSelectedDriver(null);
    }
  }, [selectedLogistics, orderStatus]);

  const isDriverDisabled = () => {
    if (!selectedLogistics || selectedLogistics.length === 0) {
      return true;
    }

    if (selectedLogistics.length > 1) {
      return true;
    }

    const logistic = selectedLogistics[0];
    if (logistic.enable_driver === undefined) {
      return true;
    }

    return logistic.enable_driver !== "1" && logistic.enable_driver !== 1;
  };

  useEffect(() => {
    if (isDriverDisabled() && selectedDriver) {
      setSelectedDriver(null);
    }
  }, [selectedLogistics, orderStatus, drivers, selectedDriver]);

  const updateOrderStatus = async (
    e = "",
    type = "",
    orderId = "",
    numberofpackages,
    order_type,
  ) => {
    const userID = getUserIdFromLocalStorage();
    const currentDate = new Date();
    const formattedDate = format(currentDate, "dd-MM-yy HH:mm:ss");
    e.preventDefault();
    if (numberofpackages > 1) {
      if (OldOrderId === orderId || !OldOrderId) {
        setNumberofpackages(numberofpackages - 1);
        setOldOrderId(orderId);
      }
    } else if (
      numberofpackages === 1 &&
      (OldOrderId === orderId || !OldOrderId)
    ) {
      setLoading(true);
      const obj = {
        logistic_id: logisticSelect || "",
        user_id: userID,
        type: type,
        nb_of_pack: constNumPack.current,
        upc_id: "",
        item: "",
        driver_id: selectedDriver?.value || "",
      };
      var url = "";
      if (order_type == "0" || order_type == "normal") {
        obj.order_id = orderId;
        url = buildLink("updateOrder");
      } else {
        obj.return_order_id = orderId;
        url = buildLink("updateReturnOrder");
      }
      setNumberofpackages(null);

      try {
        const response = await axiosServer.put(url, obj);

        const objtable = {
          date: formattedDate,
          user: stateCom.username,
          id: orderId,
          status: response.data.current_status,
          reason: response.data.message,
          success: true,
        };
        setOrdersList((prevProducts) => [objtable, ...prevProducts]);
        if (response.data.success) {
          orderListVar.push(objtable);
          handleSetCookies(orderListVar);
          setMessage(response.data.message);
          setShowMessageSucc(true);
          playSuccessSound();
          setTimeout(() => {
            setShowMessageSucc(false);
          }, 10000);
        } else {
          showError(response.data.message);
        }

        setLoading(false);

        return true;
      } catch (e) {
        const objtable = {
          date: formattedDate,
          user: stateCom.username,
          id: orderId,
          status: e.response.data.data.current_status,
          reason: e.response.data.message,
          success: false,
        };

        // Update orders list state immutably
        setOrdersList((prevProducts) => [...prevProducts, objtable]);

        // Ensure we don't mutate the state variable directly
        const updatedOrderListVar = [...orderListVar, objtable];
        handleSetCookies(updatedOrderListVar);

        setLoading(false);

        setMessage(e.response.data.message);
        setShowMessageErr(true);
        playErrorSound();

        setTimeout(() => {
          setShowMessageErr(false);
        }, 10000);

        return false;
      }

      setLoading(false);
      setOldOrderId(null);
    }
  };
  function showError(error = "") {
    setMessage(error);
    resetPackageFlow();
    setShowMessageErr(true);
    playErrorSound();
    setTimeout(() => setShowMessageErr(false), 10000);
  }

  const handleSetCookies = (list) => {
    const listString = JSON.stringify(list);
    Cookies.set("ordersHistory", listString);
  };
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const [loading1, setLoading1] = useState(false);
  const history = useNavigate();
  const [showMessgSucc, setShowMessageSucc] = useState(false);

  useEffect(() => {
    if (!numberofpackages) {
      orderId.current.blur();
      neworderId.current.focus();
    } else {
      orderId.current.focus();
    }
  }, [numberofpackages]);

  const modifiedOptions = stateLogistic.logisticList.map((option) => {
    if (selectedLogistics.length > 0) {
      const selectedValues = selectedLogistics.map((sel) => sel.value);
      const relatedValues = selectedLogistics.flatMap(
        (sel) => sel.related || [],
      );

      const shouldEnable =
        selectedValues.includes(option.value) ||
        relatedValues.includes(option.value);

      return {
        ...option,
        isDisabled: !shouldEnable,
      };
    }
    return {
      ...option,
      isDisabled: false,
    };
  });

  const handleTrashClickOrderId = () => {
    orderId.current.value = "";
    orderId.current.focus();
  };

  const handleTrashClickNewOrderId = () => {
    neworderId.current.value = "";
    resetPackageFlow();
    neworderId.current.focus();
  };

  const fetchnboackage = async (e) => {
    e.preventDefault();

    const order_id = neworderId.current.value.trim();
    const isSplitOrderId = order_id.includes("-");

    if (!order_id) {
      showError("Please Enter Order Id First");
      return;
    }

    neworderId.current.value = order_id;
    syncPackageFlowVisibility(order_id);

    let detectedOrderType = orderType;

    if (
      host == "pda.ishtari.com" ||
      host.startsWith("localhost") ||
      host == "pda.ishtari.com.gh"
    ) {
      const {
        success,
        type,
        message: orderTypeMessage,
      } = await getDetectedOrderType(order_id);

      if (!success) {
        playErrorSound();
        setMessage(orderTypeMessage);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
        return;
      }

      detectedOrderType = type;
      setorderStatus(type);
      setOrderType(type);
    }

    let order_type;

    if (
      host == "pda.ishtari.com" ||
      host.startsWith("localhost") ||
      host == "pda.ishtari.com.gh"
    ) {
      order_type = detectedOrderType === "return" ? 1 : 0;
    } else {
      order_type = orderType === "return" ? 1 : 0;
    }

    try {
      const isDriverRequired = selectedLogistics.some(
        (logistic) =>
          logistic.enable_driver === "1" || logistic.enable_driver === 1,
      );

      if (isDriverRequired && !selectedDriver) {
        showError("Driver selection is required when driver is enabled");
        return;
      }

      const logistic = logisticSelect;

      if (isSplitOrderId) {
        let obj;

        if (order_type == "0" || order_type == "normal") {
          obj = {
            order_id: order_id,
            order_type: order_type,
            type: origin_type,
            logistic_id: logistic,
            user_id: stateCom.userID,
            driver_id: selectedDriver?.value || "",
          };
        } else {
          obj = {
            return_order_id: order_id,
            order_type: order_type,
            type: origin_type,
            logistic_id: logistic,
            user_id: stateCom.userID,
            driver_id: selectedDriver?.value || "",
          };
        }

        let url;
        if (order_type == "0" || order_type == "normal") {
          url = buildLink("updateOrderV2");
        } else {
          url = buildLink("updateReturnOrderV2");
        }

        try {
          const response = await axiosServer.put(url, obj);
          const { success, message, data } = response.data || {};
          const currentDate = new Date();
          const formattedDate = format(currentDate, "dd-MM-yy HH:mm:ss");

          updateSplitScanProgress(response?.data?.package_scan ?? data);
          setMessage(message || "");

          const scannedOrderId = order_id.split("-")[0];

          if (response?.data?.data?.current_status == "given") {
            const objtable = {
              date: formattedDate,
              user: stateCom.username,
              id: scannedOrderId,
              status: response?.data?.data?.current_status,
              reason: message || response?.data?.message || "",
              success: Boolean(success),
            };
            setOrdersList((prevProducts) => [objtable, ...prevProducts]);
          }

          neworderId.current.value = "";
          neworderId.current.focus();
          setLoading1(false);

          if (success) {
            setShowMessageSucc(true);
            playSuccessSound();
            setTimeout(() => {
              setShowMessageSucc(false);
            }, 10000);
          } else {
            setShowMessageErr(true);
            playErrorSound();
            setTimeout(() => {
              setShowMessageErr(false);
            }, 10000);
          }

          return;
        } catch (error) {
          const errorResponse = error.response?.data || {};
          const currentDate = new Date();
          const formattedDate = format(currentDate, "dd-MM-yy HH:mm:ss");

          updateSplitScanProgress(errorResponse?.package_scan ?? errorResponse.data);
          setMessage(errorResponse.message || "Request failed");
          setOrdersList((prevProducts) => [
            {
              date: formattedDate,
              user: stateCom.username,
              id: order_id,
              status:
                errorResponse?.current_status ??
                errorResponse?.data?.current_status ??
                "",
              reason: errorResponse.message || "Request failed",
              success: false,
            },
            ...prevProducts,
          ]);
          setShowMessageErr(true);
          playErrorSound();
          setTimeout(() => {
            setShowMessageErr(false);
          }, 10000);
          neworderId.current.value = "";
          neworderId.current.focus();
          setLoading1(false);
          return;
        }
      }

      const url =
        buildLink("getNbOfPackage") +
        `&order_id=${order_id}&order_type=${order_type}` +
        `&type=${origin_type}&logistic=${logistic}`;
      const response = await axiosServer.get(url);
      const { success, message, data } = response.data || {};
      if (!success) {
        neworderId.current.value = "";
        showError(message || "Request failed");
        e.preventDefault();
        return;
      }

      setLoading1(false);
      orderId.current.focus();

      const nb_of_package = Number(data?.nb_of_package ?? 0);
      constNumPack.current = nb_of_package;

      if (nb_of_package === 1) {
        orderId.current.value = order_id;
        setNumberofpackages(nb_of_package);

        const res = await updateOrderStatus(
          e,
          origin_type,
          orderId.current.value,
          nb_of_package,
          order_type,
        );
        if (!res) {
          orderId.current.value = "";
          neworderId.current.value = "";
          resetPackageFlow();
        } else {
          orderId.current.value = "";
          neworderId.current.value = "";
          resetPackageFlow();
        }
        setLoading1(false);
        orderId.current.blur();
        neworderId.current.focus();
      } else if (nb_of_package > 1) {
        setNumberofpackages(nb_of_package - 1);
        setLoading1(false);
      } else {
        showError("Number Of Package is 0");
        e.preventDefault();
      }
    } catch (error) {
      neworderId.current.value = "";
      setLoading1(false);
      showError(error.response?.data?.message);
      e.preventDefault();
    }
  };

  const handleUpdateOrderStatus = async (e) => {
    if (neworderId.current.value !== orderId.current.value) {
      showError("Order IDs doesn't Match");
      e.preventDefault();
    } else {
      e.preventDefault();

      if (
        numberofpackages > 0 &&
        orderId.current.value === neworderId.current.value
      ) {
        setNumberofpackages((prev) => prev - 1);
      }

      if (numberofpackages - 1 === 0) {
        await updateOrderStatus(
          e,
          origin_type,
          orderId.current.value,
          numberofpackages,
          orderStatus,
        );
        orderId.current.value = "";
        setNumberofpackages(null);
        neworderId.current.value = "";
      }
      orderId.current.value = "";
      neworderId.current.focus();
    }
  };

  const titles = {
    given: "Given",
    hold_given: "Hold Given",
    hold_ready: "Hold Ready",
  };

  return (
    <>
      <div className=" h-full bg-white">
        {/* header */}
        <Header title={titles[origin_type] || ""} />

        <div className=" container flex flex-col gap-1 mt-3 mb-6">
          {/* Order Type */}
          {host !== "pda.ishtari.com" &&
            !host.startsWith("localhost") &&
            host !== "pda.ishtari.com.gh" && (
              <div className=" ">
                <div>Order Type</div>
                <Select
                  placeholder="Order type"
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderRadius: "7px",
                      borderColor: state.isFocused ? "grey" : "grey",
                      padding: "6px 3px",
                    }),
                  }}
                  onChange={(e) => {
                    setSelectedOption(e);
                    setorderStatus(e.value);
                    setOrderType(e.value);
                  }}
                  value={selectedOption}
                  options={options}
                />
              </div>
            )}

          {/* Logistic */}
          {/* Logistic */}
          <div className="">
            <div>Logistics</div>
            <Select
              placeholder="Logistics"
              isMulti
              value={selectedLogistics}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderRadius: "7px",
                  borderColor: state.isFocused ? "grey" : "grey",
                  outline: "red",
                  padding: "8px 5px",
                }),
              }}
              options={modifiedOptions}
              onChange={(selectedOptions) => {
                setSelectedLogistics(selectedOptions);
                if (selectedOptions.length === 1) {
                  setLogisticSelect(selectedOptions[0].value);
                } else {
                  const values = selectedOptions
                    .map((option) => option.value)
                    .join(",");
                  setLogisticSelect(values);
                }
              }}
            />
          </div>

          {/* Driver */}
          <div className="">
            <div>Driver</div>
            <Select
              placeholder="Select Driver"
              value={selectedDriver}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderRadius: "7px",
                  backgroundColor: state.isDisabled ? "#f2f2f2" : "#ffffff",
                  borderColor: state.isFocused ? "grey" : "grey",
                  padding: "6px 3px",
                }),
              }}
              onChange={(selectedOption) => {
                setSelectedDriver(selectedOption);
              }}
              options={drivers}
              isDisabled={isDriverDisabled()}
            />
          </div>

          {/* Order ID */}
          <div className="">
            <div className="p-1">Order ID:</div>
            <form onSubmit={(e) => fetchnboackage(e)} className="gap-2 flex ">
              <div className="relative flex-1">
                <input
                  ref={neworderId}
                  type="text"
                  onChange={(e) => syncPackageFlowVisibility(e.target.value)}
                  className="border-2 w-full rounded-md border-dbase px-[3px] py-[6px]"
                />
                <FaTrash
                  className="absolute top-1/2 transform -translate-y-1/2 right-2 cursor-pointer opacity-20 "
                  onClick={handleTrashClickNewOrderId}
                />
              </div>
              <div className="w-fit cursor-pointer px-5 text-white text-center rounded-md bg-dbase">
                <button className="flex  whitespace-nowrap  items-center justify-center h-full">
                  <FaSearch></FaSearch>
                </button>
              </div>
            </form>
          </div>
          {!show && splitScanProgress?.remainingPackages > 0 && (
            <div className="">
              <div className="p-1">Scanned:</div>
              <div className="space-x-3 flex flex-wrap">
                <input
                  value={`${splitScanProgress.checkedPackages}/${splitScanProgress.totalPackages}`}
                  readOnly
                  type="text"
                  className="border mb-3 border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2 bg-[#f2f2f2]"
                  placeholder="Scanned"
                />
              </div>
            </div>
          )}
          {show && (
            <>
              <div className="">
                <div className="p-1">Number of Packages:</div>
                <div className="space-x-3 flex flex-wrap">
                  <input
                    value={numberofpackages ?? ""}
                    readOnly
                    type="text"
                    className="border mb-3 border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2 bg-[#f2f2f2]"
                    placeholder="Number of Packages"
                  />
                </div>
              </div>

              <div className="">
                <div className="">Order ID</div>
                <form
                  onSubmit={(e) => handleUpdateOrderStatus(e)}
                  className="gap-2 flex "
                >
                  <div className="relative flex-1">
                    <input
                      ref={orderId}
                      type="text"
                      className="border-2 w-full rounded-md border-dbase px-[3px] py-[6px]"
                    />
                    <FaTrash
                      className="absolute top-1/2 transform -translate-y-1/2 right-2 cursor-pointer opacity-20 "
                      onClick={handleTrashClickOrderId}
                    />
                  </div>
                  <div className="w-fit cursor-pointer px-5 text-white text-center rounded-md bg-dbase">
                    <button className="flex  whitespace-nowrap  items-center justify-center h-full">
                      Mark as {titles[origin_type]}
                    </button>
                  </div>
                </form>
              </div>
            </>
          )}
        </div>
        <div className="container w-full rounded-md text-white flex justify-between ">
          <div className="border w-full flex-1  px-8  text-dgreyBlack border-dblack  py-2 flex items-center justify-center">
            {orderList.filter((order) => order.success).length}
          </div>
          <div
            onClick={() => setOrdersList([])}
            className="border cursor-pointer w-full bg-dbase   flex-2  border-dblack  py-2 flex items-center justify-center"
          >
            Reset
          </div>
        </div>
        <div class="w-full mt-3 bg-white p-3 rounded container">
          <table class="w-full border-dlabelColor border">
            <thead>
              <tr className=" border-b border-dlabelColor">
                <th class="py-2  border-dlabelColor border-r">Order ID</th>
                <th class="py-2 border-r">Status</th>
                <th class="py-2 border-dlabelColor">Reason</th>
              </tr>
            </thead>
            <tbody>
              {orderList &&
                orderList.map((item) => {
                  return (
                    <tr
                      className={` ${
                        item.success ? "text-dgreen" : "text-dbase"
                      } text-center border-b border-dlabelColor`}
                    >
                      <td class="py-2  border-dlabelColor border-r">
                        {item.id}
                      </td>
                      <td class="py-2  border-dlabelColor border-r">
                        {item.status}
                      </td>
                      <td class="py-2  border-dlabelColor border-r">
                        {item.reason}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};
export default hocStarredPage(HoldStatuses);
